import React from 'react';
import { observer } from 'mobx-react';
import { Row } from 'antd';
import { Catcher, CompaniesAssignmentsShow, DownloadFilesButtons, cardLayoutOptions } from '../../';
import { ShowRateInfo, ShowRateOperatorsList } from './';
import { IComponentV2, IShowForm } from '../../../interfaces';
import { useRateInfo } from '../../../hooks';
import { tP } from '../../../translate';
import Styles from '../../styles/m_itemCardStyles.less';
import RateListStyles from '../m_styles.less';

type IShowRate = IShowForm & IComponentV2;

export const ShowRate: React.FC<IShowRate> = observer(({ setEditMode, isV2 }: IShowRate) => {
    const { id } = useRateInfo();
    return (
        <Catcher>
            <div className={Styles.main}>
                <div className={RateListStyles.titleContainer}>
                    <h1 className={RateListStyles.title}>{`${tP('Sales Rate List')} ${isV2 ? 'V2' : ''}`}</h1>
                    <DownloadFilesButtons csvType={'GET_SALES_RATE_CSV'} id={id} />
                </div>
                <Row>
                    <ShowRateInfo setEditMode={setEditMode} isV2={isV2} />
                    <CompaniesAssignmentsShow columnOption={cardLayoutOptions.cardTableFull} />
                </Row>
                <ShowRateOperatorsList isV2={isV2} />
            </div>
        </Catcher>
    );
});
